import { twMerge } from "tailwind-merge";

export default function GaugeIcon({
  fill = "currentColor",
  className,
  ...props
}) {
  const defaultClasses = "h-[14px]";
  const mergedClassName = twMerge(defaultClasses, className);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={mergedClassName}
      viewBox="0 0 540 512"
      {...props}
    >
      <path
        fill={fill}
        d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
      />
    </svg>
  );
}
